module.exports = __webpack_public_path__ + "img/icon-checked.bbf16cac.svg";